<script lang="ts">
	import { feddbackApi } from './feddbackApi';

	let isSended = $state(false);
	let sendComplete = $state(false);
	let errorMessage = $state('');

	function onsubmit(e) {
		e.preventDefault();

		isSended = true;

		feddbackApi(new FormData(e.currentTarget))
			.then((data) => {
				// console.log('data', data);
				sendComplete = true;
			})
			.catch((error) => {
				// console.log('error', error);

				errorMessage = 'Ошибка отправки данных';
			})
			.then(() => {
				isSended = false;
			});
	}
</script>

<div class="form-phone">
	<form method="POST" {onsubmit}>
		<input type="hidden" name="name" value="anonymous" />

		<div class="form-feedback__error">
			{errorMessage}
		</div>

		<div class="form-phone__wrap">
			<span class="t-input-phonemask__select-flag" data-phonemask-flag="ru"></span>

			<input
				class="form-phone__input-phone t-input js-phonemask-input js-tilda-rule t-input_bbonly"
				autocomplete="tel"
				name="phone"
				type="tel"
				style="color: #000000; border: 1px solid #d6d6d6"
				placeholder="+7(000)000-0000"
			/>

			<div class="t-form__submit form-phone__submit">
				<button
					type="submit"
					disabled={isSended}
					class="t-submit t-btnflex t-btnflex_type_submit t-btnflex_md"
					style="
																						background-color: #e68a2b;
																						color: #ffffff;
																						border: none;
																						padding: 10px 20px;
																						border-radius: 4px;
																						cursor: pointer;
																					"
				>
					<span class="t-btnflex__text">Отправить</span>
				</button>
			</div>
		</div>

		<div class="d-flex form-phone__captcha-wrap">
			<div
				id="captcha-container"
				class="form-phone__captcha smart-captcha"
				data-sitekey="ysc1_IqbAVngS1LI9yoh7fucifCyh6yNcKQbMxEJzLy3v6602f861"
			></div>
		</div>
	</form>

	{#if sendComplete}
		<div class="form-feedback__success">Вам перезвонят</div>
	{/if}
</div>

<style lang="sass">
:global
	.form-phone
		position: relative

	.form-phone__wrap
		display: flex
		justify-content: center
		align-items: center
		gap: 1rem
		margin-bottom: 1rem

	.form-phone__input-phone
		width: 50%
		flex-shrink: 1

	.form-phone__submit
		flex-shrink: 2

	.form-phone__captcha
		width: 50%

	.form-phone__captcha-wrap
		justify-content: center
</style>
